import React, { useContext } from 'react';
import { ISOLang } from '@yandex-int/any.common/ts/types/ISOLang';
import { MovieWatchParamsFragment } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { AudioTrack } from '@kinopoisk-int/ott-player-tracker';

import { AudioConfig, SubtitleConfig } from '@/scenarios/legacy-player/components/Player';

export type Quality = 'STEREO' | 'SURROUND_51' | 'OTHER';

export type Track = AudioTrack & {
    note?: string;
    /** Default: false */
    disabled?: boolean;
    info?: AudioConfig;
};

export type Subtitles = {
    /** Track name, displayed in the interface */
    name: string;
    /** Track ID, used to switch tracks via API or selector in the interface */
    value: string;
    /**
     * Language of the track in ISO 639-1 format.
     * A string like `"ru"` or `"en"`, or an empty string if the language could not be determined.
     */
    lang: ISOLang | '';
    note?: string;
    /** Default: false */
    disabled?: boolean;
    info?: SubtitleConfig;
};

export type TrackMap = Map<string, Track>;

export interface AudioTrackContextValue {
    allAudioTracksMap: TrackMap;
    currentAudioTrack: string | undefined;
    watchParams: MovieWatchParamsFragment['watchParams'] | undefined;
}

export const AudioTrackContext = React.createContext<AudioTrackContextValue>({
    allAudioTracksMap: new Map<string, Track>(),
    currentAudioTrack: undefined,
    watchParams: undefined,
});

export const useAudioTrackContext = () => useContext(AudioTrackContext);

export type JoinDataLeft<T> = {
    data: readonly T[];
    getKey: (track: T) => string;
};

export type JoinDataRight<T> = {
    data?: T[];
    getKey: (track: T) => string;
};
